import React from 'react';
import { useIntl } from 'react-intl';

import ClientLayoutComponent from '@/components/ClientLayout/ClientLayoutComponent';
import { useUser } from '@/contexts/UserContext';

const ClientLayoutContainer = ({ ...props }) => {
  const user = useUser();
  const intl = useIntl();

  return <ClientLayoutComponent user={user} intl={intl} {...props} />;
};

export default ClientLayoutContainer;
